import React from 'react';
import { BRAND_WIDGET_LAYOUT_TYPE_V2, BrandWidgetDetailV2 } from '../../../../../../types/widget';
import PreviewGrid from '../../../../../../components/preview/PreviewGrid';
import BrandSimpleCard from './BrandSimpleCard';
import BrandCard from './BrandCard';
import BrandWidgetCard from './BrandWidgetCard';
import BrandSwipeCard from './BrandSwipeCard';
import Modal from '../../../../../../components/Modal';
import WidgetPreviewHeader from '../../../common/components/WidgetPreviewHeader';

interface BrandWidgetPreviewModalProps {
  isOpen: boolean;
  detail: BrandWidgetDetailV2;
  onClose: () => void;
}

const BrandWidgetPreviewModal = (props: BrandWidgetPreviewModalProps) => {
  const { isOpen, detail, onClose } = props;
  const getLayoutView = (detail: BrandWidgetDetailV2) => {
    switch (detail.layoutType) {
      case BRAND_WIDGET_LAYOUT_TYPE_V2.GRID_1X4:
        return (
          <PreviewGrid col={4} colGap={5} style={{ padding: '0px 15px' }}>
            {detail.exposureWidgetItemBrands?.map((item) => <BrandSimpleCard key={item.id} widgetBrandItem={item} />)}
          </PreviewGrid>
        );
      case BRAND_WIDGET_LAYOUT_TYPE_V2.GRID_2X2:
        return (
          <PreviewGrid col={2} colGap={15} rowGap={15} style={{ padding: '0px 15px' }}>
            {detail.exposureWidgetItemBrands?.map((item) => <BrandCard key={item.id} widgetBrandItem={item} />)}
          </PreviewGrid>
        );
      case BRAND_WIDGET_LAYOUT_TYPE_V2.SCROLL_NX1:
        return (
          <PreviewGrid col={1} rowGap={20}>
            {detail.exposureWidgetItemBrands?.map((item) => <BrandWidgetCard key={item.id} widgetBrandItem={item} />)}
          </PreviewGrid>
        );
      case BRAND_WIDGET_LAYOUT_TYPE_V2.SCROLL_BLANK_NX1:
        return (
          <PreviewGrid col={1} rowGap={20} style={{ padding: '0px 15px' }}>
            {detail.exposureWidgetItemBrands?.map((item) => <BrandWidgetCard key={item.id} widgetBrandItem={item} />)}
          </PreviewGrid>
        );
      case BRAND_WIDGET_LAYOUT_TYPE_V2.SWIPE:
        return <BrandSwipeCard widgetBrandList={detail.exposureWidgetItemBrands} />;
    }
  };

  return (
    <div>
      <Modal
        title={'위젯 미리보기'}
        wrapClassName="widget-preview-modal-wrapper"
        isOpen={isOpen}
        width={375}
        height={700}
        padding={'0px'}
        isFooter={true}
        okText="확인"
        onOk={onClose}
        onClose={onClose}
      >
        <WidgetPreviewHeader mainTitle={detail.mainTitle} subTitle={detail.subTitle} />
        {getLayoutView(detail)}
      </Modal>
    </div>
  );
};

export default BrandWidgetPreviewModal;
